import {Component} from '@angular/core';
import {NavigationEnd, NavigationExtras, Router} from '@angular/router';
import { CustomAuthService } from './auth.service';
import {Banner} from './shared/banner/banner';
import {AlertService} from './alert.service';

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    banner: Banner;
    loggedIn = false;
    isHome = true;
    isAdmin = false;
    publicView = true;
    name = 'Welcome Back!';
    userPic = 'https://icon-library.net/images/default-user-icon/default-user-icon-4.jpg';

    constructor(private router: Router, public authService: CustomAuthService, private alertService: AlertService) {

        this.router.events.subscribe((ev) => {
            if (ev instanceof NavigationEnd) {
                console.log('route changed');
                this.checkHome();
            }
        });
        authService.loggedInStream$.subscribe(
            val => {
                this.loggedIn = val;
            });
        authService.isAdminStream$.subscribe(
            val => {
                this.isAdmin = val;
            });
        authService.userNameStream$.subscribe(
            val => {
                this.name = val;
            });
        authService.userPicStream$.subscribe(
            val => {
                if (val) {
                    this.userPic = val;
                }
            });
        alertService.bannerStream$.subscribe(
            val => {
                this.banner = val;
            });

        // to check session and if exists then login
        const loggedIn = localStorage.getItem('loggedIn');
        if (loggedIn) {
            this.authService.sendToRestApiMethodDevMode(loggedIn);
        }
    }

    checkHome() {
        const urlSplitted = window.location.href.split('/');
        if (urlSplitted.length === 4 && urlSplitted[3] === '') {
            this.isHome = true;
        } else {
            this.isHome = false;
        }
    }

    public logIn() {
        if (this.loggedIn) {
            if (this.isAdmin) {
                this.router.navigate(['admin']);
            } else {
                this.router.navigate(['customer/tiles']);
            }
        } else {
            this.router.navigate(['login']);
        }
    }

    public logOut() {
        this.authService.logout();
        this.router.navigate(['']);
        this.alertService.warn('You have been successfully logged out');
    }
}
